import React, { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import Button from "../Button";
import { Colors } from "../../config";
import CancelTicketModal from "../ModalPages/CancelTicketModal";
import ErrorModal from "../ErrorSuccessModal/ErrorModal";
// import { useIntercom } from "react-use-intercom";

const HeaderButtonWrapper = ({
  onShowChat,
  status,
  requestId,
  customerEndCancel,
  navigate,
  id,
  isBusinessTrip,
  hasChildDocument
}) => {
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);

  const employeeDetails = localStorage.getItem("employeeData");
  const employee = JSON.parse(employeeDetails);

  // const { boot, update, show, hide } = useIntercom();

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          // hide();
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const closeModal = () => {
    setOpenCancelModal(false);
  };

  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  // const updateWithProps = () => {
  // onShowChat();
  // boot();
  // update({
  //   name: employee.firstName + " - " + requestId,
  //   userId: requestId,
  //   email: employee.email,
  // });
  // show();
  // };

  return (
    <ButtonWrapper isRejected={status === "Rejected"} ref={wrapperRef}>
      {/* <Button
        label="Chat with Joury Travel Agent"
        onClick={onShowChat}
        bgColor={Colors.brandOne}
        borderRadius="11.25rem"
        topBottomPadding="0.938rem"
        fontSize="1rem"
        fontWeight="700"
        leftRightPadding="2.313rem"
      /> */}
      {isBusinessTrip && !customerEndCancel && !hasChildDocument &&
        !["cancel_through_customer", "amended",'rejected'].includes(status) && (
          <Button
            label="Edit Booking"
            bgColor={Colors.transparent}
            outlineColor={Colors.white}
            topBottomPadding="0.938rem"
            onClick={() => navigate(`/user/edit-business-trip/${id}`)}
          />
        )}
      {!customerEndCancel && !hasChildDocument && (
        <>
          {!["cancel_through_customer", "amended",'rejected'].includes(status) && (
            <Button
              label="Cancel Request"
              onClick={() => setOpenCancelModal(true)}
              bgColor={Colors.mediumCandyAppleRed}
              borderRadius="11.25rem"
              topBottomPadding="0.938rem"
              fontSize="1rem"
              fontWeight="700"
              leftRightPadding="2.313rem"
            />
          )}
        </>
      )}
      {openCancelModal && (
        <CancelTicketModal
        reqId={id}
          isBusinessTrip={isBusinessTrip}
          setClose={closeModal}
          setBackendErrorMsg={setBackendErrorMsg}
        />
      )}
      {backendErrorMsg && (
        <ErrorModal
          subheaderText={backendErrorMsg}
          setClose={closeErrorModal}
          onButtonClick={closeErrorModal}
        />
      )}
    </ButtonWrapper>
  );
};

export default HeaderButtonWrapper;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.25rem;
  width: 27rem;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }
  ${(props) =>
    props.isRejected &&
    css`
      width: 13rem;
    `}
`;
